import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiAxios from 'helpers/apiAxios';
import { toast } from 'react-toastify';

export const fetchDashboard = createAsyncThunk(
  'bookingDashboard/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiAxios.get('/booking/dashboard');
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

const EMPTY_STATS = {
  // Booking
  travel_this_month: 0,  travel_prev_month: 0,
  car_this_month: 0,     car_prev_month: 0,
  pending_car: 0,        pending_travel: 0,
  pending_approvals: 0,  overdue_count: 0,
  // CRM (current user only)
  crm_projects_this: 0,  crm_projects_prev: 0,
  crm_customers_this: 0, crm_customers_prev: 0,
  crm_contacts_this: 0,  crm_contacts_prev: 0,
  crm_leads_this: 0,     crm_leads_prev: 0,
  new_bookings_this: 0,  new_bookings_prev: 0,
};

const dashboardSlice = createSlice({
  name: 'booking_dashboard',
  initialState: {
    stats:           { ...EMPTY_STATS },
    monthly_trend:   [],
    pending_items:   [],
    upcoming:        [],
    recent_activity: [],
    crm:             [],
    loading:         false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => { state.loading = true; })
      .addCase(fetchDashboard.fulfilled, (state, { payload }) => {
        state.loading         = false;
        state.stats           = payload.stats           || EMPTY_STATS;
        state.monthly_trend   = payload.monthly_trend   || [];
        state.pending_items   = payload.pending_items   || [];
        state.upcoming        = payload.upcoming        || [];
        state.recent_activity = payload.recent_activity || [];
        state.crm             = payload.crm             || [];
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload?.error || 'Failed to load dashboard');
      });
  },
});

export default dashboardSlice.reducer;
